export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6210.28523480.jpg";